/** Rechnungsadresse für die Prüfspalte im Angebot (Antoine 12.10.2026: „schnell zur Adresse kommen
 *  und prüfen, ob sie vollständig ist"). Dieselbe Regel wie `apps/api/src/lib/rechnungsadresse.ts`
 *  `rechnungsadresseVollstaendig`: Name oder Firma vom Kunden, Straße/PLZ/Ort aus der
 *  Auftragsadresse, wenn sie vollständig ist, sonst vom Kunden. */
type AdressWert = string | null | undefined;

export interface AdressQuelle {
  name?: AdressWert;
  company?: AdressWert;
  addressStreet?: AdressWert;
  addressZip?: AdressWert;
  addressCity?: AdressWert;
  eventAddressStreet?: AdressWert;
  eventAddressZip?: AdressWert;
  eventAddressCity?: AdressWert;
}

const da = (v: AdressWert) => Boolean(v?.trim());

export function pruefeRechnungsadresse(q: AdressQuelle): { fehlt: string[]; zeile: string } {
  const auftrag = da(q.eventAddressStreet) && da(q.eventAddressZip) && da(q.eventAddressCity);
  const strasse = auftrag ? q.eventAddressStreet : q.addressStreet;
  const plz = auftrag ? q.eventAddressZip : q.addressZip;
  const ort = auftrag ? q.eventAddressCity : q.addressCity;
  const empfaenger = q.company?.trim() || q.name?.trim() || "";
  const fehlt = [
    !empfaenger && "Name oder Firma",
    !da(strasse) && "Straße",
    !da(plz) && "PLZ",
    !da(ort) && "Ort",
  ].filter((x): x is string => Boolean(x));
  const zeile = [empfaenger, strasse?.trim(), [plz?.trim(), ort?.trim()].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  return { fehlt, zeile };
}
